import { ElementRef, EventEmitter } from '@angular/core';
import { CommonService } from '../../common.service';
var QuestionnaireTextareaComponent = (function () {
    function QuestionnaireTextareaComponent(el, commonService) {
        this.el = el;
        this.commonService = commonService;
        this.outPutTextareaContext = new EventEmitter(); //回传textarea的value
        this.isShowPlaceholder = true; //是否显示placeholder
    }
    QuestionnaireTextareaComponent.prototype.ngOnInit = function () {
        this.textarea = this.el.nativeElement.querySelector('textarea');
    };
    QuestionnaireTextareaComponent.prototype.ngAfterViewInit = function () {
    };
    QuestionnaireTextareaComponent.prototype.ngOnChanges = function (changes) {
        if (changes.selectedTag) {
            this.showSelectedTag();
        }
    };
    //展示选择的标签
    QuestionnaireTextareaComponent.prototype.showSelectedTag = function () {
        var target = this.el.nativeElement.querySelector('textarea');
        target.value = this.selectedTag;
        this.outPutTextareaContext.emit(target.value);
    };
    //隐藏Placeholder
    QuestionnaireTextareaComponent.prototype.closePlaceholder = function () {
        this.isShowPlaceholder = false;
        this.textarea.focus();
    };
    //textarea获取焦点事件
    QuestionnaireTextareaComponent.prototype.textareaFocus = function () {
        this.isShowPlaceholder = false;
    };
    //textarea失去焦点触发事件
    QuestionnaireTextareaComponent.prototype.textareaBlur = function () {
        this.commonService.initPage();
        this.isShowPlaceholder = this.textarea.value === "";
        this.outPutTextareaContext.emit(this.textarea.value);
    };
    return QuestionnaireTextareaComponent;
}());
export { QuestionnaireTextareaComponent };



// WEBPACK FOOTER //
// ./src/app/app-questionnaire/questionnaire-textarea/questionnaire-textarea.component.ts.pre-build-optimizer.js